import { render, staticRenderFns } from "./Relevance.vue?vue&type=template&id=4cfa7040&scoped=true&"
import script from "./Relevance.vue?vue&type=script&lang=js&"
export * from "./Relevance.vue?vue&type=script&lang=js&"
import style0 from "./Relevance.vue?vue&type=style&index=0&id=4cfa7040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa7040",
  null
  
)

export default component.exports